import api from '@Base/services/solicitudService.js';
import {
  createBlobFromResponse,
  createBlobFromByteArray,
  downloadDocument,
} from '@Base/utils/helpers.js';

export default {
  namespaced: true,
  state: {
    tituloModulo: 'Prestación por cese de actividad para autónomos',
    subtituloModulo: '',
    pasoActual: 1,
    pasoTotal: 10,
    tituloPasoActual: '',
    tokenGestion: '',
    tokenAcceso: '',
    solicitante: null,
    idSolicitud: null,
    totalNotificaciones: 0,
    pdfCompletado: false,
    pdfCargado: false,
    estadoExpedienteActualizado: null,
    idNotificacion: null,
    audFirma: {},
    idNotificacionFavorableAbono: null,
  },

  getters: {
    tipoDocumentoAudFirma: (state) => state.audFirma.tipoDocumento || null,
  },

  actions: {},

  mutations: {
    setIdNotificacionFavorableAbono(state, id) {
      state.idNotificacionFavorableAbono = id;
    },
    setIdConfirmacion(state, id) {
      state.idConfirmacion = id;
    },
    setTipoConfirmacion(state, tipo) {
      state.tipoConfirmacion = tipo;
    },
    setTituloModulo(state, tituloModulo) {
      state.tituloModulo = tituloModulo;
    },
    setSubtituloModulo(state, subtituloModulo) {
      state.subtituloModulo = subtituloModulo;
    },
    setPasoActual(state, pasoActual) {
      state.pasoActual = pasoActual;
    },
    setTokenGestion(state, tokenGestion) {
      state.tokenGestion = tokenGestion;
    },
    setSolicitante(state, solicitante) {
      state.solicitante = solicitante;
    },
    setTokenAcceso(state, tokenAcceso) {
      state.tokenAcceso = tokenAcceso;
    },
    setTotalNotificaciones(state, totalNotificaciones) {
      state.totalNotificaciones = totalNotificaciones;
    },
    setPdfCompletado(state, completado) {
      state.pdfCompletado = completado;
    },
    setPdfCargado(state, cargado) {
      state.pdfCargado = cargado;
    },
    setEstadoExpedienteActualizado(state, estado) {
      state.estadoExpedienteActualizado = estado;
    },
    SET_ID_NOTIFICACION(state, idNotificacion) {
      state.idNotificacion = idNotificacion;
    },
    SET_AUD_FIRMA(state, audFirma = {}) {
      state.audFirma = audFirma;
    },
  },
};
